; (function ($) {
    var Widgets = {
        /**
         * @property hoverBindingEnable
         * @type boolean
         * @default true
         */
        hoverBindingEnable: true,

        /**
         * hover事件
         * @method hoverBinding
         */
        hoverBinding: function () {
            if (!this.hoverBindingEnable) {
                return;
            }

            $('body').on('mouseenter', '[data-role="hover-container"]', function () {
                var hoverName = $(this).data('hover-name');
                $('[data-role="hover-box"][data-hover-name="' + hoverName + '"]').show();
                return false;
            }).on('mouseleave', '[data-role="hover-container"]', function () {
                var hoverName = $(this).data('hover-name');
                $('[data-role="hover-box"][data-hover-name="' + hoverName + '"]').hide();
                return false;
            });

            this.hoverBindingEnable = false;
        },
        
        /**
         * @property tabBindingEnable
         * @type boolean
         * @default true
         */
        tabBindingEnable: true,
        
        /**
         * tab事件
         * @method hoverBinding
         */
        tabBinding: function () {
            if (!this.tabBindingEnable) {
                return;
            }

            $('body').on('click mouseenter', '[data-role="tab-btn"]', function (e) {
                var tabFire = $(this).data('tab-fire') || 'click';
                if (e.type != tabFire) {
                    return;
                }

                var tabName = $(this).data('tab-name');
                var tabAbout = $(this).data('tab-about');
                $('[data-role="tab-btn"][data-tab-name="' + tabName + '"]')
                    .removeClass('cur')
                    .filter('[data-tab-about="' + tabAbout + '"]')
                    .addClass('cur');
                $('[data-role="tab-box"][data-tab-name="' + tabName + '"]')
                    .hide()
                    .filter('[data-tab-about="' + tabAbout + '"]')
                    .show();
                return false;
            });
            this.tabBindingEnable = false;
        },

        /**
         * @property radioBindingEnable
         * @type boolean
         * @default true
         */
        radioBindingEnable: true,
        
        /**
         * radio按钮
         * @method hoverBinding
         */
        radioBinding: function () {
            if (!this.radioBindingEnable) {
                return;
            }

            $('body').on('click', '[role="radio"]', function () {
                var $cont = $(this).closest('[role="radiogroup"]');
                $cont.find('[role="radio"]')
                    .find('.ico_radio')
                    .removeClass('checked');
                $(this).find('.ico_radio')
                    .addClass('checked');
            });
            this.radioBindingEnable = false;
        },
        
        selectBindingEnable: true,
        
        selectBinding: function () {
            if (!this.selectBindingEnable) {
                return;
            }
            
            $('body').on('click', '[role="select-show"]', function () {
                var $select = $(this).closest('[role="select"]');
                var $option_wraper = $select.find('[role="option-wraper"]');
                $option_wraper.toggle();
            });
            
            $('body').on('click', '[role="option"]', function () {
                var $this = $(this);
                var $select = $this.closest('[role="select"]');
                var $select_show = $select.find('[role="select-show"]');
                var $option_wraper = $select.find('[role="option-wraper"]');
                var $ignore = $this.find('[aria-ignore]');
                var value = $this.attr('aria-value');
                var text;
                if ($ignore.length === 0) {
                    text = $this.text();
                } else {
                    text = $this.html().replace($ignore.prop('outerHTML'), '');
                }
                if (value === $select.attr('aria-value')) {
                    $option_wraper.hide();
                    return;
                }
                
                $select.attr('aria-value', value);
                $select_show.text(text);
                $option_wraper.hide();
                // 自定义组件值改变事件 xl9.ui.selectchange
                $('[role="select"]').trigger('xl9.ui.selectchange');
            });
            
            $('body').on('click', function (e) {
                var $target = $(e.target);
                var $select = $target.closest('[role="select"]');
                if ($select.length === 0) {
                    $('[role="option-wraper"]').hide();
                    // 自定义组件失去焦点事件 xl9.ui.selectblur
                    $('[role="select"]').trigger('xl9.ui.selectblur');
                }
            });
            
            selectBindingEnable = false;
        }
    };

    if (typeof exports === 'object') {
        module.exports = Widgets;
    }
})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/widgets.js
// module id = 22
// module chunks = 1 2 5 6 10